var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenBookmarks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_612_1248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#47C87A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_612_1248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19.1667V5.83337C2.5 5.37504 2.66306 4.98282 2.98917 4.65671C3.31583 4.33004 3.70833 4.16671 4.16667 4.16671H12.5C12.9583 4.16671 13.3508 4.33004 13.6775 4.65671C14.0036 4.98282 14.1667 5.37504 14.1667 5.83337V19.1667L8.33333 16.6667L2.5 19.1667ZM15.8333 16.6667V2.50004H5V0.833374H15.8333C16.2917 0.833374 16.6842 0.99643 17.0108 1.32254C17.3369 1.64921 17.5 2.04171 17.5 2.50004V16.6667H15.8333Z",
    fill: "#47C87A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBookmarks);
export default __webpack_public_path__ + "static/media/greenBookmarks.2412fcf5c0b3227e82aada57fac5ada4.svg";
export { ForwardRef as ReactComponent };